"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.processCategories = exports.SERVICES = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _memoizee = _interopRequireDefault(require("memoizee"));
var _codes = require("@raywhite/data-utils/lib/data/listing/codes");
var _helpers = require("@raywhite/data-utils/lib/data/meta/helpers");
var _string = require("@raywhite/helpers-utils/lib/helpers/string");
var SERVICES = exports.SERVICES = {
  buy: 'buy',
  rent: 'rent',
  sell: 'sell',
  propertymanagement: 'property-management'
};
var byTotal = (a, b) => b.total - a.total;

// Note: other types appear in both, ALP
var groups = {
  HOL: 'rent',
  REN: 'rent',
  CLR: 'buy',
  LVS: 'buy',
  LVW: 'buy',
  RUR: 'buy',
  SAL: 'buy',
  BUS: 'buy',
  COMSAL: 'buy',
  COMLSE: 'rent'
};

/**
 * Generate the typed sub pages to be used on a service page from the metadata
 * about the types of listings that a site has.
 *
 * @param {String} category [ buy | rent | sell | property-management ] The type of
 *                 service page being shown.
 * @param {Object} meta     The metadata for the site, loaded via unifiedClient.
 *
 * @return {Array[Object]} A list of available typed sections within the service
 *                         page, each with name, type and count data.
 */
var processCategory = (category, meta) => {
  var _context, _context2;
  var raw = (0, _filter.default)(_context = (0, _map.default)(_context2 = (0, _entries.default)(meta)).call(_context2, _ref => {
    var [typeKey, data] = _ref;
    var typeCode = (0, _helpers.reformatTypeCode)(typeKey);
    var name = (0, _codes.describeType)(typeCode, false);
    var single = (0, _codes.describeType)(typeCode, true);
    return {
      typeKey,
      typeCode,
      name,
      single,
      slug: (0, _string.toSlug)(name),
      total: data.total,
      data
    };
  })).call(_context, item => item.name);
  switch (category) {
    case 'buy':
    case 'rent':
      return (0, _reduce.default)(raw).call(raw, (result, item) => {
        var _context3, _context4;
        if (!item.data.statusCode.CUR) return result;
        var group = groups[item.typeKey];
        if (group && group !== category) return result;
        var subTypeCode = (0, _slice.default)(_context3 = item.typeKey).call(_context3, 3);
        var data = item.data.statusCode.CUR;
        result.push({
          ...item,
          total: data.total,
          data,
          statusCode: 'CUR',
          subTypeCode: subTypeCode && subTypeCode !== 'BOTH' ? {
            in: [subTypeCode]
          } : {
            not: [category === 'buy' ? 'LSE' : 'SAL']
          },
          sort: 'updatedAt desc',
          pageDescription: (0, _concat.default)(_context4 = "".concat(item.name, " ")).call(_context4, (0, _codes.describeTypeStatus)(item.typeCode, 'CUR'))
        });
        return result;
      }, []);
    case 'sell':
      return (0, _reduce.default)(raw).call(raw, (result, item) => {
        if (!item.data.statusCode.SLD) return result;
        var data = {
          ...item.data.statusCode.SLD
        };
        data.inspections = {
          total: 0
        };
        data.auctions = {
          total: 0
        };
        result.push({
          ...item,
          total: data.total,
          data,
          statusCode: 'SLD',
          sort: 'soldDate desc',
          pageDescription: "Sold ".concat(item.name)
        });
        return result;
      }, []);
    case 'property-management':
      return (0, _reduce.default)(raw).call(raw, (result, item) => {
        if (!item.data.statusCode.LSE) return result;
        var data = {
          ...item.data.statusCode.LSE
        };
        data.inspections = {
          total: 0
        };
        data.auctions = {
          total: 0
        };
        result.push({
          ...item,
          total: data.total,
          data,
          statusCode: 'LSE',
          sort: 'updatedAt desc',
          pageDescription: "Leased ".concat(item.name)
        });
        return result;
      }, []);
    default:
      throw new Error("Invalid category ".concat(category, " for service page."));
  }
};

/**
 * Collapse BOTH subTyped results where present.
 *
 * The BOTH subType will cause duplicate categories if present along with the
 * SAL or LSE subtypes, so in this case it should be excluded and its total
 * added to the others.
 *
 * TODO: more complete merging of counts from BOTH onto totals
 */
var mergeSubTypes = categories => {
  var boths = (0, _filter.default)(categories).call(categories, _ref2 => {
    var {
      typeKey
    } = _ref2;
    return (0, _slice.default)(typeKey).call(typeKey, 3) === 'BOTH';
  });

  // If no BOTHs found, all is well
  if (!boths.length) return categories;
  var result = [...categories];
  (0, _forEach.default)(boths).call(boths, both => {
    var _context5;
    var sale = both.typeKey.replace('BOTH', 'SAL');
    var lease = both.typeKey.replace('BOTH', 'LSE');
    (0, _forEach.default)(_context5 = [sale, lease]).call(_context5, typeKey => {
      var matches = (0, _filter.default)(categories).call(categories, category => category.typeKey === typeKey);

      // No match found
      if (!matches.length) return;
      var [other] = matches;

      // Match found, add it to the total and drop out the "both" record
      other.total += both.total;
      other.data.inspections.total += both.data.inspections.total;
      other.data.auctions.total += both.data.auctions.total;

      // Apply the more permissive "both" subTypeCode
      other.subTypeCode = both.subTypeCode;
      var index = (0, _indexOf.default)(result).call(result, both);
      if (index !== -1) (0, _splice.default)(result).call(result, index, 1);
    });
  });
  return result;
};

/**
 * Memoized processort to extract type data into appropriate categories as
 * required.
 */
var processCategories = exports.processCategories = (0, _memoizee.default)(meta => {
  var _context6;
  return (0, _reduce.default)(_context6 = (0, _values.default)(SERVICES)).call(_context6, (result, category) => {
    var _context7;
    result[category] = (0, _sort.default)(_context7 = mergeSubTypes(processCategory(category, meta))).call(_context7, byTotal);
    return result;
  }, {});
}, {
  max: 5
});